module.exports = __webpack_public_path__ + "static/media/fl2-cover-title.9a33623f.png";